// extracted by mini-css-extract-plugin
export default {"separator":"Separator_separator__pmpfM","asDiv":"Separator_asDiv__ZWiyQ","authoring":"Separator_authoring__GSbn7"};